'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp, _initialiseProps;

var _reactRedux = require('react-redux');

var _wish_list = require('redux/actions/wish_list');

var _modal = require('redux/actions/modal');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ModifierModal: {
        displayName: 'ModifierModal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/ModifierModal/ModifierModal.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ModifierModal = _wrapComponent('ModifierModal')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        currency: state.currency
    };
}, { wishListUpdateProduct: _wish_list.wishListUpdateProduct, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ModifierModal, _Component);

    function ModifierModal(props, context) {
        (0, _classCallCheck3.default)(this, ModifierModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModifierModal.__proto__ || (0, _getPrototypeOf2.default)(ModifierModal)).call(this, props, context));

        _initialiseProps.call(_this);

        var modValuesId0 = 'all';
        var modValuesId1 = 'all';
        var modValuesId2 = 'all';
        var modValueDefault = null;
        _this.props.product_detail.modifier_option_id = undefined;

        if (_this.props.product_detail.modifiedOption !== undefined && _this.props.product_detail.type_id !== 5) {
            if (_this.props.product_detail.price_backup === undefined) {
                _this.props.product_detail.price_backup = _this.props.product_detail.price;
            }
            _this.props.product_detail.modifiedOption.forEach(function (item) {
                if (item.is_default) {
                    modValueDefault = item.id;
                    _this.props.product_detail.modifier_option_id = item.id;
                    _this.props.product_detail.modifier_option = item;
                    _this.props.product_detail.modifierName = _this.props.product_detail.modifier_option.name;
                    if (_this.props.product_detail.type_id === 5) {
                        _this.props.product_detail.price = _this.props.product_detail.price_backup * 1 + _this.props.product_detail.modifier_option.price * 1;
                    } else {
                        _this.props.product_detail.price = _this.props.product_detail.modifier_option.price;
                    }
                    _this.props.product_detail.id_yml = _this.props.product_detail.modifier_option.id_yml;
                }
            });
            if (modValueDefault) {
                var modValueId = [];
                _this.props.product_detail.valueOption.forEach(function (item) {
                    if (item.option_id === modValueDefault) {
                        modValueId.push(item.value_id);
                    }
                });
                if (_this.props.product_detail.modifier[0] !== undefined) {
                    var modValues0 = _this.props.product_detail.modifier[0].values.filter(function (value) {
                        return modValueId.indexOf(value.id) !== -1;
                    });
                    if (modValues0.length === 1) {
                        modValuesId0 = modValues0[0].id;
                    }
                }
                if (_this.props.product_detail.modifier[1] !== undefined) {
                    var modValues1 = _this.props.product_detail.modifier[1].values.filter(function (value) {
                        return modValueId.indexOf(value.id) !== -1;
                    });
                    if (modValues1.length === 1) {
                        modValuesId1 = modValues1[0].id;
                    }
                }
                if (_this.props.product_detail.modifier[2] !== undefined) {
                    var modValues2 = _this.props.product_detail.modifier[2].values.filter(function (value) {
                        return modValueId.indexOf(value.id) !== -1;
                    });
                    if (modValues2.length === 1) {
                        modValuesId2 = modValues2[0].id;
                    }
                }
            }
        }
        if (_this.props.product_detail.type_id === 5) {
            _this.listNested = [];
            _this.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
                _this.getNestedOfferAllList(nestedOffer, 1);
                if (nestedOffer.childOffer.type_id === 5) {
                    if (nestedOffer.valuesMods === undefined || nestedOffer.valuesMods === null) {
                        nestedOffer.valuesMods = ['all', 'all', 'all'];
                        nestedOffer.modifierName = '';
                        nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
                            if (nestedOfferChild.modifierOption !== null) {
                                nestedOfferChild.childOffer.modifier_option_id = nestedOfferChild.modifierOption.id;
                                nestedOfferChild.childOffer.modOption = nestedOfferChild.modifierOption;
                                nestedOfferChild.childOffer.price = nestedOfferChild.modifierOption.price;
                                nestedOfferChild.childOffer.modifierName = nestedOfferChild.modifierOption.name;
                            }
                        });
                    }
                } else {
                    if (nestedOffer.modifierOption !== null) {
                        nestedOffer.childOffer.modifier_option_id = nestedOffer.modifierOption.id;
                        nestedOffer.childOffer.modOption = nestedOffer.modifierOption;
                        nestedOffer.childOffer.price = nestedOffer.modifierOption.price;
                        nestedOffer.childOffer.modifierName = nestedOffer.modifierOption.name;
                    }
                }
            });
            _this.props.product_detail.modifierName = '';
            if (_this.props.product_detail.valuesMods === undefined || _this.props.product_detail.valuesMods === null) {
                _this.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
                _this.props.product_detail.modifierName = '';
            } else {
                modValuesId0 = _this.props.product_detail.valuesMods[0];
                modValuesId1 = _this.props.product_detail.valuesMods[1];
                modValuesId2 = _this.props.product_detail.valuesMods[2];
            }
            var currentValue = null;
            if (modValuesId0 !== 'all') {
                currentValue = null;
                currentValue = _this.props.product_detail.modifier[0].values.filter(function (value) {
                    return value.id == modValuesId0;
                });
                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId1 !== 'all') {
                _currentValue = null;
                var _currentValue = _this.props.product_detail.modifier[1].values.filter(function (value) {
                    return value.id == modValuesId1;
                });
                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[1].name + ': ' + _currentValue[0].name + ' ';
            }
            if (modValuesId2 !== 'all') {
                _currentValue2 = null;
                var _currentValue2 = _this.props.product_detail.modifier[2].values.filter(function (value) {
                    return value.id == modValuesId2;
                });
                _this.props.product_detail.modifierName += _this.props.product_detail.modifier[2].name + ': ' + _currentValue2[0].name + ' ';
            }
        }

        _this.state = {
            modValues0: _this.props.product_detail.modifier[0] !== undefined ? _this.props.product_detail.modifier[0].values : null,
            modValues1: _this.props.product_detail.modifier[1] !== undefined ? _this.props.product_detail.modifier[1].values : null,
            modValues2: _this.props.product_detail.modifier[2] !== undefined ? _this.props.product_detail.modifier[2].values : null,
            modValuesId0: modValuesId0,
            modValuesId1: modValuesId1,
            modValuesId2: modValuesId2,
            changeQuantity: 10,
            changeChildMods: 10
        };
        return _this;
    }

    (0, _createClass3.default)(ModifierModal, [{
        key: 'getNestedOfferAllList',
        value: function getNestedOfferAllList(nestedOffer, level) {
            var _this2 = this;

            var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            nestedOffer.level = level;
            nestedOffer.parentId = parentId;
            this.listNested.push(nestedOffer);
            if (nestedOffer.childOffer.type_id === 5) {
                nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
                    _this2.getNestedOfferAllList(nestedOfferChild, level + 1, nestedOffer.id);
                });
            }
        }
    }, {
        key: 'setModOptionIdActive',
        value: function setModOptionIdActive(modOptionIdActive) {
            var _this3 = this;

            if (modOptionIdActive.length === 1) {
                this.props.product_detail.modifier_option_id = modOptionIdActive[0];
                this.setState({ modifier_option_id: modOptionIdActive[0] });
                this.props.product_detail.modifier_option = this.props.product_detail.modifiedOption.filter(function (value) {
                    return value.id === _this3.props.product_detail.modifier_option_id;
                })[0];
                this.props.product_detail.modifierName = this.props.product_detail.modifier_option.name;
                if (this.props.product_detail.type_id === 5) {
                    if (this.props.product_detail.price_backup === undefined) {
                        this.props.product_detail.price_backup = this.props.product_detail.price;
                    }
                    this.props.product_detail.price = this.props.product_detail.price_backup * 1 + this.props.product_detail.modifier_option.price * 1;
                } else {
                    this.props.product_detail.price = this.props.product_detail.modifier_option.price;
                }
                this.props.product_detail.id_yml = this.props.product_detail.modifier_option.id_yml;
            }
        }
    }, {
        key: 'recalculatePriceForMods',
        value: function recalculatePriceForMods() {
            var _this4 = this;

            if (this.props.product_detail.type_id === 5) {
                if (this.props.product_detail.price_backup === undefined) {
                    this.props.product_detail.price_backup = this.props.product_detail.price;
                }
                if (this.props.product_detail.price_backup_no_mod === undefined) {
                    this.props.product_detail.price_backup_no_mod = this.props.product_detail.price;
                }
                this.props.product_detail.price = this.props.product_detail.price_backup_no_mod * 1;
                var modValuesId0 = this.state.modValuesId0;
                if (this.props.product_detail.modifier[0] !== undefined) {
                    this.props.product_detail.modifier[0].values.forEach(function (item) {
                        if (item.id == modValuesId0) {
                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
                        }
                    });
                }
                var modValuesId1 = this.state.modValuesId1;
                if (this.props.product_detail.modifier[1] !== undefined) {
                    this.props.product_detail.modifier[1].values.forEach(function (item) {
                        if (item.id == modValuesId1) {
                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
                        }
                    });
                }
                var modValuesId2 = this.state.modValuesId2;
                if (this.props.product_detail.modifier[2] !== undefined) {
                    this.props.product_detail.modifier[2].values.forEach(function (item) {
                        if (item.id == modValuesId2) {
                            _this4.props.product_detail.price = _this4.props.product_detail.price + item.price;
                        }
                    });
                }
                this.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
                    if (nestedOffer.childOffer.type_id === 5) {
                        if (nestedOffer.valuesMods === undefined) {
                            nestedOffer.valuesMods = ['all', 'all', 'all'];
                        }
                        nestedOffer.modifierName = '';
                        if (nestedOffer.childOffer.modifier[0] !== undefined && nestedOffer.valuesMods[0] !== null) {
                            nestedOffer.childOffer.modifier[0].values.forEach(function (item) {
                                if (item.id == nestedOffer.valuesMods[0]) {
                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[0].name + ': ' + item.name + ' ';
                                }
                            });
                        }
                        if (nestedOffer.childOffer.modifier[1] !== undefined && nestedOffer.valuesMods[1] !== null) {
                            nestedOffer.childOffer.modifier[1].values.forEach(function (item) {
                                if (item.id == nestedOffer.valuesMods[1]) {
                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[1].name + ': ' + item.name + ' ';
                                }
                            });
                        }
                        if (nestedOffer.childOffer.modifier[2] !== undefined && nestedOffer.valuesMods[2] !== null) {
                            nestedOffer.childOffer.modifier[2].values.forEach(function (item) {
                                if (item.id == nestedOffer.valuesMods[2]) {
                                    _this4.props.product_detail.price = _this4.props.product_detail.price + item.price * nestedOffer.quantity;
                                    nestedOffer.modifierName += nestedOffer.childOffer.modifier[2].name + ': ' + item.name + ' ';
                                }
                            });
                        }
                    }
                });
            }
        }
    }, {
        key: 'recalculatePrice',
        value: function recalculatePrice(id, priceDiff) {
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'plus';

            for (var key in this.listNested) {
                if (this.listNested[key].id === id) {
                    if (type === 'minus') {
                        this.listNested[key].childOffer.price = this.listNested[key].childOffer.price * 1 - priceDiff * 1;
                    } else {
                        this.listNested[key].childOffer.price = this.listNested[key].childOffer.price * 1 + priceDiff * 1;
                    }
                    if (this.listNested[key].parentId) {
                        this.recalculatePrice(this.listNested[key].parentId, priceDiff * this.listNested[key].quantity, type);
                    } else {
                        if (type === 'minus') {
                            this.props.product_detail.price = this.props.product_detail.price * 1 - priceDiff * this.listNested[key].quantity;
                        } else {
                            this.props.product_detail.price = this.props.product_detail.price * 1 + priceDiff * this.listNested[key].quantity;
                        }
                    }
                    break;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('ModifierModal', null, { folderName: 'Basket/ModifierModal' });

            return _react3.default.createElement(View, (0, _extends3.default)({}, this.props, {
                modValues0: this.state.modValues0,
                modValues1: this.state.modValues1,
                modValues2: this.state.modValues2,
                modValuesId: this.state.modValuesId,
                handleSelect0: this.handleSelect0,
                handleSelect1: this.handleSelect1,
                handleSelect2: this.handleSelect2,
                modValuesId0: this.state.modValuesId0,
                modValuesId1: this.state.modValuesId1,
                modValuesId2: this.state.modValuesId2,
                closeModal: this.closeModal,
                lang: this.props.lang,
                currency: this.props.currency,
                onClickPlusNested: this.onClickPlusNested,
                onClickMinusNested: this.onClickMinusNested,
                onClickPlusChildNested: this.onClickPlusChildNested,
                onClickMinusChildNested: this.onClickMinusChildNested,
                changeQuantity: this.state.changeQuantity,
                handleSelectChildOffer: this.handleSelectChildOffer,
                changeChildMods: this.state.changeChildMods,
                listNested: this.listNested
            }));
        }
    }]);
    return ModifierModal;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.closeModal = function () {
        _this5.props.hide();
    };

    this.handleSelect0 = function (e) {
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup === undefined) {
                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
            }
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
            var modValuesId0 = e.target.value;
            _this5.setState({ modValuesId0: e.target.value });
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
                    if (item.id == modValuesId0) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId1 = _this5.state.modValuesId1;
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
                    if (item.id == modValuesId1) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId2 = _this5.state.modValuesId2;
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
                    if (item.id == modValuesId2) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            _this5.props.product_detail.modValuesId0 = modValuesId0;
            _this5.props.product_detail.modValuesId1 = modValuesId1;
            _this5.props.product_detail.modValuesId2 = modValuesId2;
            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
            _this5.props.product_detail.modifierName = '';
            var currentValue = null;
            if (modValuesId0 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
                    return value.id == modValuesId0;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId1 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
                    return value.id == modValuesId1;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId2 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
                    return value.id == modValuesId2;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
            }
            return true;
        }
        if (e.target.value == 'all') {
            _this5.setState({ modValuesId0: e.target.value });
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.setState({ modValues1: _this5.props.product_detail.modifier[1].values });
            }
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.setState({ modValues2: _this5.props.product_detail.modifier[2].values });
            }
            _this5.props.product_detail.modifier_option_id = undefined;
        } else {
            _this5.setState({ modValuesId0: e.target.value * 1 });
            var modOptionId = [];
            var filterModOptionId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (item.value_id === e.target.value * 1) {
                    modOptionId.push(item.option_id);
                }
            });
            var modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            var modValueId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
                    modValueId.push(item.value_id);
                }
            });
            var _modValuesId = _this5.state.modValuesId1;
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                var modValues1 = _this5.props.product_detail.modifier[1].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues1: modValues1 });
                if (modValues1.length === 1) {
                    _modValuesId = modValues1[0].id;
                    _this5.setState({ modValuesId1: modValues1[0].id });
                }
            }
            var _modValuesId2 = _this5.state.modValuesId2;
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                var modValues2 = _this5.props.product_detail.modifier[2].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues2: modValues2 });
                if (modValues2.length === 1) {
                    _modValuesId2 = modValues2[0].id;
                    _this5.setState({ modValuesId2: modValues2[0].id });
                }
            }
            if (_modValuesId !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            if (_modValuesId2 !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId2 && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            _this5.setModOptionIdActive(modOptionIdActive);
        }
        _this5.props.wishListUpdateProduct();
    };

    this.handleSelect1 = function (e) {
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup === undefined) {
                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
            }
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
            var modValuesId0 = _this5.state.modValuesId0;
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
                    if (item.id == modValuesId0) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId1 = e.target.value;
            _this5.setState({ modValuesId1: e.target.value });
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
                    if (item.id == modValuesId1) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId2 = _this5.state.modValuesId2;
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
                    if (item.id == modValuesId2) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            _this5.props.product_detail.modValuesId0 = modValuesId0;
            _this5.props.product_detail.modValuesId1 = modValuesId1;
            _this5.props.product_detail.modValuesId2 = modValuesId2;
            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
            _this5.props.product_detail.modifierName = '';
            var currentValue = null;
            if (modValuesId0 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
                    return value.id == modValuesId0;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId1 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
                    return value.id == modValuesId1;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId2 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
                    return value.id == modValuesId2;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
            }
            return true;
        }
        if (e.target.value == 'all') {
            _this5.setState({ modValuesId1: e.target.value });
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.setState({ modValues0: _this5.props.product_detail.modifier[0].values });
            }
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.setState({ modValues2: _this5.props.product_detail.modifier[2].values });
            }
            _this5.props.product_detail.modifier_option_id = undefined;
        } else {
            _this5.setState({ modValuesId1: e.target.value * 1 });
            var modOptionId = [];
            var filterModOptionId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (item.value_id === e.target.value * 1) {
                    modOptionId.push(item.option_id);
                }
            });
            var modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            var modValueId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
                    modValueId.push(item.value_id);
                }
            });
            var _modValuesId3 = _this5.state.modValuesId0;
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                var modValues0 = _this5.props.product_detail.modifier[0].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues0: modValues0 });
                if (modValues0.length === 1) {
                    _modValuesId3 = modValues0[0].id;
                    _this5.setState({ modValuesId0: modValues0[0].id });
                }
            }
            var _modValuesId4 = _this5.state.modValuesId2;
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                var modValues2 = _this5.props.product_detail.modifier[2].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues2: modValues2 });
                if (modValues2.length === 1) {
                    _modValuesId4 = modValues2[0].id;
                    _this5.setState({ modValuesId2: modValues2[0].id });
                }
            }
            if (_modValuesId3 !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId3 && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            if (_modValuesId4 !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId4 && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            _this5.setModOptionIdActive(modOptionIdActive);
        }
        _this5.props.wishListUpdateProduct();
    };

    this.handleSelect2 = function (e) {
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup === undefined) {
                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
            }
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
            var modValuesId0 = _this5.state.modValuesId0;
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
                    if (item.id == modValuesId0) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId1 = _this5.state.modValuesId1;
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
                    if (item.id == modValuesId1) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }

            var modValuesId2 = e.target.value;
            _this5.setState({ modValuesId2: e.target.value });
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
                    if (item.id == modValuesId2) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            _this5.props.product_detail.modValuesId0 = modValuesId0;
            _this5.props.product_detail.modValuesId1 = modValuesId1;
            _this5.props.product_detail.modValuesId2 = modValuesId2;
            _this5.props.product_detail.valuesMods = [modValuesId0, modValuesId1, modValuesId2];
            _this5.props.product_detail.modifierName = '';
            var currentValue = null;
            if (modValuesId0 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[0].values.filter(function (value) {
                    return value.id == modValuesId0;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[0].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId1 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[1].values.filter(function (value) {
                    return value.id == modValuesId1;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[1].name + ': ' + currentValue[0].name + ' ';
            }
            if (modValuesId2 !== 'all') {
                currentValue = null;
                currentValue = _this5.props.product_detail.modifier[2].values.filter(function (value) {
                    return value.id == modValuesId2;
                });
                _this5.props.product_detail.modifierName += _this5.props.product_detail.modifier[2].name + ': ' + currentValue[0].name + ' ';
            }
            return true;
        }
        if (e.target.value == 'all') {
            _this5.setState({ modValuesId2: e.target.value });
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.setState({ modValues0: _this5.props.product_detail.modifier[0].values });
            }
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.setState({ modValues1: _this5.props.product_detail.modifier[1].values });
            }
            _this5.props.product_detail.modifier_option_id = undefined;
        } else {
            _this5.setState({ modValuesId2: e.target.value * 1 });
            var modOptionId = [];
            var filterModOptionId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (item.value_id === e.target.value * 1) {
                    modOptionId.push(item.option_id);
                }
            });
            var modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            var modValueId = [];
            _this5.props.product_detail.valueOption.forEach(function (item) {
                if (modOptionIdActive.indexOf(item.option_id) !== -1) {
                    modValueId.push(item.value_id);
                }
            });
            var _modValuesId5 = _this5.state.modValuesId0;
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                var modValues0 = _this5.props.product_detail.modifier[0].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues0: modValues0 });
                if (modValues0.length === 1) {
                    _modValuesId5 = modValues0[0].id;
                    _this5.setState({ modValuesId0: modValues0[0].id });
                }
            }
            var _modValuesId6 = _this5.state.modValuesId1;
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                var modValues1 = _this5.props.product_detail.modifier[1].values.filter(function (value) {
                    return modValueId.indexOf(value.id) !== -1;
                });
                _this5.setState({ modValues1: modValues1 });
                if (modValues1.length === 1) {
                    _modValuesId6 = modValues1[0].id;
                    _this5.setState({ modValuesId1: modValues1[0].id });
                }
            }
            if (_modValuesId5 !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId5 && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            if (_modValuesId6 !== 'all') {
                filterModOptionId = modOptionId;
                modOptionId = [];
                _this5.props.product_detail.valueOption.forEach(function (item) {
                    if (item.value_id === _modValuesId6 && filterModOptionId.indexOf(item.option_id) !== -1) {
                        modOptionId.push(item.option_id);
                    }
                });
            }
            modOptionIdActive = [];
            _this5.props.product_detail.modifiedOption.forEach(function (item) {
                if (modOptionId.indexOf(item.id) !== -1) {
                    if (item.enable === true) {
                        modOptionIdActive.push(item.id);
                    }
                }
            });
            _this5.setModOptionIdActive(modOptionIdActive);
        }
        _this5.props.wishListUpdateProduct();
    };

    this.handleSelectChildOffer = function (e, mod_id, child_offer_id) {
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup === undefined) {
                _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
            }
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.price = _this5.props.product_detail.price_backup_no_mod * 1;
            var modValuesId0 = _this5.state.modValuesId0;
            if (_this5.props.product_detail.modifier[0] !== undefined) {
                _this5.props.product_detail.modifier[0].values.forEach(function (item) {
                    if (item.id == modValuesId0) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId1 = _this5.state.modValuesId1;
            if (_this5.props.product_detail.modifier[1] !== undefined) {
                _this5.props.product_detail.modifier[1].values.forEach(function (item) {
                    if (item.id == modValuesId1) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            var modValuesId2 = _this5.state.modValuesId2;
            if (_this5.props.product_detail.modifier[2] !== undefined) {
                _this5.props.product_detail.modifier[2].values.forEach(function (item) {
                    if (item.id == modValuesId2) {
                        _this5.props.product_detail.price = _this5.props.product_detail.price + item.price;
                    }
                });
            }
            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
                if (nestedOffer.id === child_offer_id && nestedOffer.childOffer.type_id === 5) {
                    if (nestedOffer.valuesMods === undefined) {
                        nestedOffer.valuesMods = ['all', 'all', 'all'];
                    }
                    nestedOffer.modifierName = '';
                    nestedOffer.valuesMods[mod_id] = e.target.value;
                    if (nestedOffer.childOffer.modifier[0] !== undefined && nestedOffer.valuesMods[0] !== null) {
                        nestedOffer.childOffer.modifier[0].values.forEach(function (item) {
                            if (item.id == nestedOffer.valuesMods[0]) {
                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[0].name + ': ' + item.name + ' ';
                            }
                        });
                    }
                    if (nestedOffer.childOffer.modifier[1] !== undefined && nestedOffer.valuesMods[1] !== null) {
                        nestedOffer.childOffer.modifier[1].values.forEach(function (item) {
                            if (item.id == nestedOffer.valuesMods[1]) {
                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[1].name + ': ' + item.name + ' ';
                            }
                        });
                    }
                    if (nestedOffer.childOffer.modifier[2] !== undefined && nestedOffer.valuesMods[2] !== null) {
                        nestedOffer.childOffer.modifier[2].values.forEach(function (item) {
                            if (item.id == nestedOffer.valuesMods[2]) {
                                _this5.props.product_detail.price = _this5.props.product_detail.price + item.price * nestedOffer.quantity;
                                nestedOffer.modifierName += nestedOffer.childOffer.modifier[2].name + ': ' + item.name + ' ';
                            }
                        });
                    }
                    var changeChildMods = _this5.state.changeChildMods;
                    changeChildMods++;
                    _this5.setState({ changeChildMods: changeChildMods });
                    return true;
                }
            });
        }
    };

    this.onClickMinusNested = function (event, id) {
        event.preventDefault();
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            for (var key in _this5.listNested) {
                var nestedOffer = _this5.listNested[key];
                if (nestedOffer.id === id && nestedOffer.quantity > 0) {
                    var MIN_COUNT_OF_NESTED_OFFER = nestedOffer.hasOwnProperty('quantity_min') ? nestedOffer.quantity_min : 0;
                    nestedOffer.stepQuantity = nestedOffer.ratio;
                    if (!nestedOffer.stepQuantity || nestedOffer.stepQuantity === 0) {
                        nestedOffer.stepQuantity = 1;
                    }
                    if (nestedOffer.quantity - nestedOffer.stepQuantity >= MIN_COUNT_OF_NESTED_OFFER) {
                        nestedOffer.quantity = nestedOffer.quantity - nestedOffer.stepQuantity;
                        if (nestedOffer.quantity < 0) {
                            nestedOffer.quantity = 0;
                        }
                        if (nestedOffer.childOffer.unit.slug === 'kg' || nestedOffer.childOffer.unit.slug === 'mg') {
                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(3));
                        } else {
                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(2));
                        }
                        _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
                        if (nestedOffer.parentId) {
                            _this5.recalculatePrice(nestedOffer.parentId, nestedOffer.childOffer.price * nestedOffer.stepQuantity, 'minus');
                        } else {
                            _this5.props.product_detail.price = _this5.props.product_detail.price * 1 - nestedOffer.childOffer.price * nestedOffer.stepQuantity;
                        }
                    }
                    break;
                }
            }
            var changeQuantity = _this5.state.changeQuantity;
            changeQuantity++;
            _this5.setState({ changeQuantity: changeQuantity });
        }
    };

    this.onClickPlusNested = function (event, id) {
        event.preventDefault();
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }

            for (var key in _this5.listNested) {
                var nestedOffer = _this5.listNested[key];
                if (nestedOffer.id === id) {
                    var MAX_COUNT_OF_NESTED_OFFER = nestedOffer.quantity_max === null ? 999999999999999999 : nestedOffer.quantity_max;
                    nestedOffer.stepQuantity = nestedOffer.ratio;
                    if (!nestedOffer.stepQuantity || nestedOffer.stepQuantity === 0) {
                        nestedOffer.stepQuantity = 1;
                    }
                    if (nestedOffer.quantity * 1 + nestedOffer.stepQuantity * 1 <= MAX_COUNT_OF_NESTED_OFFER) {
                        nestedOffer.quantity = nestedOffer.quantity * 1 + nestedOffer.stepQuantity * 1;
                        if (nestedOffer.childOffer.unit.slug === 'kg' || nestedOffer.childOffer.unit.slug === 'mg') {
                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(3));
                        } else {
                            nestedOffer.quantity = parseFloat(nestedOffer.quantity.toFixed(2));
                        }
                        _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
                        if (nestedOffer.parentId) {
                            _this5.recalculatePrice(nestedOffer.parentId, nestedOffer.childOffer.price * nestedOffer.stepQuantity, 'plus');
                        } else {
                            _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.stepQuantity;
                        }
                    }
                    break;
                }
            }
            var changeQuantity = _this5.state.changeQuantity;
            changeQuantity++;
            _this5.setState({ changeQuantity: changeQuantity });
        }
    };

    this.onClickMinusChildNested = function (event, id, child_id) {
        event.preventDefault();
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
                if (nestedOffer.id === id && nestedOffer.childOffer.type_id === 5) {
                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 - nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 - nestedOffer.childOffer.price * nestedOffer.quantity;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
                        if (nestedOfferChild.id === child_id && nestedOfferChild.quantity > 0) {
                            var MIN_COUNT_OF_NESTED_OFFER = nestedOfferChild.hasOwnProperty('quantity_min') ? nestedOfferChild.quantity_min : 0;
                            nestedOfferChild.stepQuantity = nestedOfferChild.ratio;
                            if (!nestedOfferChild.stepQuantity || nestedOfferChild.stepQuantity === 0) {
                                nestedOfferChild.stepQuantity = 1;
                            }
                            if (nestedOfferChild.quantity - nestedOfferChild.stepQuantity >= MIN_COUNT_OF_NESTED_OFFER) {
                                nestedOfferChild.quantity = nestedOfferChild.quantity - nestedOfferChild.stepQuantity;
                                if (nestedOfferChild.quantity < 0) {
                                    nestedOfferChild.quantity = 0;
                                }
                                if (nestedOfferChild.childOffer.unit.slug === 'kg' || nestedOfferChild.childOffer.unit.slug === 'mg') {
                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(3));
                                } else {
                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(2));
                                }
                                nestedOffer.childOffer.price = nestedOffer.childOffer.price - nestedOfferChild.childOffer.price * nestedOfferChild.stepQuantity;
                            }
                        }
                    });
                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
                }
            });
            _this5.recalculatePriceForMods();
            var changeQuantity = _this5.state.changeQuantity;
            changeQuantity++;
            _this5.setState({ changeQuantity: changeQuantity });
        }
    };

    this.onClickPlusChildNested = function (event, id, child_id) {
        event.preventDefault();
        if (_this5.props.product_detail.type_id === 5) {
            if (_this5.props.product_detail.price_backup_no_mod === undefined) {
                _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price;
            }
            _this5.props.product_detail.nestedOffers.forEach(function (nestedOffer) {
                if (nestedOffer.id === id && nestedOffer.childOffer.type_id === 5) {
                    _this5.props.product_detail.price = _this5.props.product_detail.price - nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod - nestedOffer.childOffer.price * nestedOffer.quantity;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferChild) {
                        if (nestedOfferChild.id === child_id) {
                            var MAX_COUNT_OF_NESTED_CHILD_OFFER = nestedOfferChild.quantity_max === null ? 999999999999999999 : nestedOfferChild.quantity_max;
                            nestedOfferChild.stepQuantity = nestedOfferChild.ratio;
                            if (!nestedOfferChild.stepQuantity || nestedOfferChild.stepQuantity === 0) {
                                nestedOfferChild.stepQuantity = 1;
                            }
                            if (nestedOfferChild.quantity * 1 + nestedOfferChild.stepQuantity * 1 <= MAX_COUNT_OF_NESTED_CHILD_OFFER) {
                                nestedOfferChild.quantity = nestedOfferChild.quantity + nestedOfferChild.stepQuantity;
                                if (nestedOfferChild.childOffer.unit.slug === 'kg' || nestedOfferChild.childOffer.unit.slug === 'mg') {
                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(3));
                                } else {
                                    nestedOfferChild.quantity = parseFloat(nestedOfferChild.quantity.toFixed(2));
                                }
                                nestedOffer.childOffer.price = nestedOffer.childOffer.price * 1 + nestedOfferChild.childOffer.price * nestedOfferChild.stepQuantity;
                            }
                        }
                    });
                    _this5.props.product_detail.price = _this5.props.product_detail.price * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup_no_mod = _this5.props.product_detail.price_backup_no_mod * 1 + nestedOffer.childOffer.price * nestedOffer.quantity;
                    _this5.props.product_detail.price_backup = _this5.props.product_detail.price;
                }
            });
            _this5.recalculatePriceForMods();
            var changeQuantity = _this5.state.changeQuantity;
            changeQuantity++;
            _this5.setState({ changeQuantity: changeQuantity });
        }
    };
}, _temp)) || _class));

exports.default = ModifierModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/ModifierModal/ModifierModal.jsx
// module id = 1617
// module chunks = 0